import React, { Component } from "react";
import { css } from "react-emotion";
import Deal from "./Deal";
import { Deal as DealForm } from "components";
import { withRedux } from "helpers";
import { flexColumn } from "appStyles";

const container = css`
  ${flexColumn}
  position: relative;
  z-index: 2;
  width: 100%;
  height: 90%;
  overflow-y: scroll;
  padding: 15px;

  * {
    margin-bottom: 5px;
  }
  ::-webkit-scrollbar {
    height: 4px;
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.075);
  }

  ::-webkit-scrollbar-thumb {
    background-color: rgb(192, 192, 192);
    border-radius: 10px;
    width: 8px;
    height: 4px;
    &:hover {
      background-color: rgb(124, 124, 124);
    }
  }
`;

class Deals extends Component {
  state = {
    renderDialog: false,
  };
  toggleActiveEditor = (idx) => {
    let {
      actions: { updateActiveEditor },
    } = this.props;
    // console.log("changing active editor!");
    updateActiveEditor(idx);
    // console.log("rendering alert!");
    this.setState({ renderDialog: true });
    // console.log(this.state.renderDialog);
  };

  componentWillUnmount() {
    let { activeEditor } = this.props;

    if (activeEditor) {
      this.props.actions.refreshActiveEditor();
    }
  }

  render() {
    const {
      activeTemplate: { backgroundColor },
      deals,
      activeEditor,
      activeApp: { id },
    } = this.props;

    const activeDeal = deals[activeEditor];

    if (!deals) return null;

    const sortedIds = [];
    Object.keys(deals).forEach((id) => {
      const deal = deals[id];
      if (deal.retired) {
        sortedIds.push(id);
      } else {
        sortedIds.unshift(id);
      }
    });

    return (
      <div className={container}>
        {deals &&
          sortedIds.map((id) => {
            const deal = deals[id];
            const border = activeEditor == id ? "2px solid red" : null;
            if (deal.retired != 1)
              return (
                <Deal
                  {...deal}
                  border={border}
                  background={backgroundColor}
                  key={id}
                  onClick={this.toggleActiveEditor}
                  barColor={this.props.activeApp.view.navigation.navBarColor}
                />
              );
          })}
      </div>
    );
  }
}

export default withRedux(Deals);
